import React from "react";
import { Button } from "@mui/material";

const DSPrimaryButton = (props: React.ComponentProps<typeof Button>) => {
  return <Button color={"primary"} variant="contained" {...props} />;
};

export default DSPrimaryButton;
